module.exports = __webpack_public_path__ + "static/img/jialebipuke.96cbec8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/jialebipuke.jpg
// module id = tbN9
// module chunks = 0